import styles from './LanguageDot.module.css'

interface LanguageDotProps {
  color: string | undefined
  variant?: string
}

export function LanguageDot({color, variant}: LanguageDotProps) {
  return (
    <span
      style={{backgroundColor: color}}
      className={variant === 'compact' ? styles.languageDotCompact : styles.languageDot}
    />
  )
}

try{ LanguageDot.displayName ||= 'LanguageDot' } catch {}